module.exports = __webpack_public_path__ + "static/media/indicator_submitting@3x.2ea72bb6.gif";